import { getAllUrlParam, removeParamUrl } from "helper"
import { param, toggleLoader } from "signals/base"
import { catch_error, get_translate } from "./base"
import axios from "axios"
import { get_info } from "./user"

const ls = window.localStorage

const set_token = () => {
	toggleLoader(true)
	const urlParams = getAllUrlParam()
	const lsParams = ls.getItem("lsParams") && JSON.parse(ls.getItem("lsParams"))
	let parameter = Object.keys(urlParams).length === 0 ? lsParams : urlParams
	get_translate(`ID`)

	if((parameter?.jwtToken) || (parameter?.accessToken)){
		let headerParam = `token`;
		if(parameter?.accessToken){
			headerParam = `access_token`;
		}
		axios.defaults.params = {}
		axios.defaults.params[headerParam] = parameter?.jwtToken || parameter?.accessToken
		get_info()
		param.value = parameter
		ls.setItem("lsParams", JSON.stringify(parameter))
		removeParamUrl()

	}else{
		/** Handle error , show modal or toast error */
		ls.clear()
		catch_error("not_logged_in")
		return
	}
}

export { set_token }
